import { render } from "./TemplateDocKp.vue?vue&type=template&id=6123d3d4&scoped=true"
import script from "./TemplateDocKp.vue?vue&type=script&lang=js"
export * from "./TemplateDocKp.vue?vue&type=script&lang=js"

import "./TemplateDocKp.vue?vue&type=style&index=0&id=6123d3d4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6123d3d4"]])

export default __exports__